import React, { useEffect } from "react";

export const NotFound = () => {
  const styles = {
    container404: {
      width: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      textAlign: "center",
      backgroundColor: "#f9f9f9",
      color: "#333",
      fontFamily: "Arial, sans-serif",
    },
    pantalla: {
      padding: "2rem",
    },
    code: {
      fontSize: "2rem",
      fontWeight: "bold",
      marginBottom: "1rem",
      color: "#3F6A88",
    },
    message: {
      fontSize: "1.5rem",
      marginBottom: "1rem",
      color: "#333333",
    },
    contact: {
      fontSize: "1rem",
      color: "#1d3557",
    },
    negrita: {
      fontWeight: "bold",
    },
  };

  useEffect(() => {
    const originalBackground = document.body.style.backgroundColor;
    document.body.style.backgroundColor = "rgb(249, 249, 249)";

    return () => {
      document.body.style.backgroundColor = originalBackground;
    };
  }, []);

  return (
    <div style={styles.container404}>
      <div style={styles.pantalla}>
        <img alt="Veritran" width={300} src="/img/veritran_logo.svg" />
        <div style={styles.code}>This view does not exist</div>
        <div style={styles.contact}>
          Please contact{" "}
          <span style={styles.negrita}>presales@veritran.com</span>
        </div>
      </div>
    </div>
  );
};
